import { Loader } from '@googlemaps/js-api-loader';

export const GoogleMapLoader = new Loader({
  apiKey: 'AIzaSyAY-HsXXPsBUqsbQLDFO8kpNWLANwH0E7k',
  libraries: ['places']
});
